import axios from 'axios';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/react';
import Routes from '../router/routes';

const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}/admin`,
  timeout: 30000, // 30 second timeout to prevent hung requests
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  const token = Cookies.get('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  async (response) => response,
  (error) => {
    Sentry.captureException(error);

    // Don't redirect on auth endpoints where 401 is expected
    const authEndpoints = ['/auth/login', '/auth/verify-2fa', '/auth/setup-2fa', '/auth/enable-2fa'];
    const isAuthEndpoint = authEndpoints.some(endpoint =>
      error.config?.url?.includes(endpoint)
    );

    if (error.response?.status === 401 && !isAuthEndpoint) {
      Cookies.remove('admin_token');
      window.location.href = Routes.login.path;
    }
    // Reject the full error object to preserve error context (status, message, etc.)
    return Promise.reject(error);
  },
);

export default axiosInstance;
